import React from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    Link,
    useNavigate
} from 'react-router-dom';

import {
    resetearConfigPacienteAction
} from '../../actions/resetStoreActions.js';

// css
import {
    Flex,
    Ubicacion,
    Div,
    Enlace,
    InfoPaciente,
    ContenedorSelectorPaciente,
    SelectorPaciente
} from '../Css/StyledHeader.js';


const Header2 = (props) => {

    const dispatch =
        useDispatch();

    const navigate =
        useNavigate();


    /*
    ====================================
    PACIENTE GLOBAL
    ====================================

    Este es el paciente seleccionado
    normalmente en YÖGEN.

    Se sigue usando en todas las
    pantallas actuales.
    ====================================
    */

    const nombre =
        useSelector(
            (state) =>
                state.usuario.nombrePaciente
        );

    const apellido =
        useSelector(
            (state) =>
                state.usuario.apellidoPaciente
        );


    /*
    ====================================
    DESELECCIONAR PACIENTE GLOBAL
    ====================================

    Mantiene exactamente el comportamiento
    histórico del HeaderDos.

    Esto NO se usa cuando el header
    funciona como selector de Estadísticas.
    ====================================
    */

    const deseleccionarPaciente = (e) => {

        e.preventDefault();

        navigate(
            "/escritorio/pacientes"
        );

        dispatch(
            resetearConfigPacienteAction()
        );

    };


    /*
    ====================================
    CAMBIAR PACIENTE DESDE SELECTOR
    ====================================

    HeaderDos no modifica Redux.

    Simplemente informa al componente
    padre cuál fue el valor elegido.

    Esto permite que Estadísticas y Cobros
    maneje su propio paciente sin cambiar
    el paciente global de toda la plataforma.
    ====================================
    */

    const cambiarPacienteSelector = (e) => {

        if (
            typeof props.onCambiarPaciente !==
            'function'
        ) {
            return;
        }

        props.onCambiarPaciente(
            e.target.value
        );

    };


    /*
    ====================================
    LISTA DE PACIENTES
    ====================================
    */

    const pacientesSelector =
        Array.isArray(props.pacientes)
            ? props.pacientes
            : [];


    return (

        <Div
            bgcolor={props.bgcolor}
            shadow={props.shadow}
            padding={props.padding1}
            color={props.color}
        >

            <Flex align="center">

                {props.l4

                    ? (

                        <Flex align="center">

                            <Link
                                to={`/escritorio/${props.l1}`}
                            >
                                <img
                                    alt=''
                                    src={`/img/icono_logo_blanco.png`}
                                />
                            </Link>

                            <Enlace
                                to={`/escritorio/${props.l1}${props.l2}`}
                            >
                                {props.n2}
                            </Enlace>

                            <Enlace
                                to={`/escritorio/${props.l1}${props.l2}${props.l3}`}
                            >
                                {props.n3}
                            </Enlace>

                            <Enlace
                                to={`/escritorio/${props.l1}${props.l2}${props.l3}${props.l4}`}
                            >
                                {props.n4}
                            </Enlace>

                            <Ubicacion>
                                {props.componente}
                            </Ubicacion>

                        </Flex>

                    )

                    : props.l3

                        ? (

                            <Flex align="center">

                                <Enlace
                                    to={`/escritorio/${props.l1}`}
                                >
                                    <img
                                        alt=''
                                        src={`/img/icono_logo_blanco.png`}
                                    />
                                </Enlace>

                                <Enlace
                                    to={`/escritorio/${props.l1}${props.l2}`}
                                >
                                    {props.n2}
                                </Enlace>

                                <Enlace
                                    to={`/escritorio/${props.l1}${props.l2}${props.l3}`}
                                >
                                    {props.n3}
                                </Enlace>

                                <Ubicacion>
                                    {props.componente}
                                </Ubicacion>

                            </Flex>

                        )

                        : props.l2

                            ? (

                                <Flex align="center">

                                    <Enlace
                                        to={`/escritorio/${props.l1}`}
                                    >
                                        <img
                                            alt=''
                                            src={`/img/icono_logo_blanco.png`}
                                        />
                                    </Enlace>

                                    <Enlace
                                        to={`/escritorio/${props.l1}${props.l2}`}
                                    >
                                        {props.n2}
                                    </Enlace>

                                    <Ubicacion>
                                        {props.componente}
                                    </Ubicacion>

                                </Flex>

                            )

                            : props.l1

                                ? (

                                    <Flex align="center">

                                        <Enlace
                                            to={`/escritorio/${props.l1}`}
                                        >
                                            <img
                                                alt=''
                                                src={`/img/icono_logo_blanco.png`}
                                            />
                                        </Enlace>

                                        <Ubicacion>
                                            {props.componente}
                                        </Ubicacion>

                                    </Flex>

                                )

                                : props.componente

                                    ? (

                                        <Flex align="center">

                                            <Ubicacion>
                                                {props.componente}
                                            </Ubicacion>

                                        </Flex>

                                    )

                                    : null
                }


                {/*
                ====================================
                SELECTOR DE PACIENTE
                ====================================

                Solo aparece cuando una pantalla
                manda selectorPaciente={true}.
                ====================================
                */}

                {props.selectorPaciente === true ? (

                    <ContenedorSelectorPaciente>

                        <InfoPaciente>
                            Paciente:
                        </InfoPaciente>


                        <SelectorPaciente
                            value={
                                props.idPacienteSeleccionado ||
                                ''
                            }
                            onChange={
                                cambiarPacienteSelector
                            }
                        >

                            {props.permitirTodosPacientes === true ? (

                                <option value="TODOS">
                                    Todos los pacientes
                                </option>

                            ) : (

                                <option value="">
                                    Seleccionar paciente
                                </option>

                            )}


                            {pacientesSelector.map(
                                (paciente) => {

                                    const nombreCompleto =
                                        `${paciente.apellido || ''}, ${paciente.nombre || ''}`
                                            .replace(/^,\s*/, '')
                                            .trim();

                                    return (

                                        <option
                                            key={
                                                paciente.id_paciente
                                            }
                                            value={
                                                paciente.id_paciente
                                            }
                                        >

                                            {
                                                nombreCompleto ||
                                                'Paciente sin nombre'
                                            }

                                        </option>

                                    );

                                }
                            )}

                        </SelectorPaciente>

                    </ContenedorSelectorPaciente>

                ) : (

                    /*
                    ====================================
                    HEADER TRADICIONAL
                    ====================================

                    Todo lo existente sigue igual.
                    ====================================
                    */

                    props.paciente === false

                        ? null

                        : nombre !== ""

                            ? (

                                <Flex $justify="flex-end">

                                    <InfoPaciente>
                                        Paciente: {apellido}, {nombre}
                                    </InfoPaciente>

                                    <button
                                        onClick={
                                            (e) =>
                                                deseleccionarPaciente(e)
                                        }
                                    >
                                        X
                                    </button>

                                </Flex>

                            )

                            : (

                                <Flex $justify="flex-end">

                                    <InfoPaciente>
                                        Paciente: sin elegir
                                    </InfoPaciente>

                                </Flex>

                            )

                )}

            </Flex>

        </Div>

    );

};


export default Header2;